module.exports = "select{z-index:99}a{font-size:.8em}a.active{background-color:lightgray}\n"